import { render, staticRenderFns } from "./CoursePlan.vue?vue&type=template&id=b741baba&scoped=true&"
import script from "./CoursePlan.vue?vue&type=script&lang=js&"
export * from "./CoursePlan.vue?vue&type=script&lang=js&"
import style0 from "./CoursePlan.vue?vue&type=style&index=0&id=b741baba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b741baba",
  null
  
)

export default component.exports